import { NgModule } from '@angular/core'
import { UnicampCoreLoadComponent } from './unicamp-core-load.component'

@NgModule({
  imports: [],
  declarations: [UnicampCoreLoadComponent],
  exports: [UnicampCoreLoadComponent],
})
export class UnicampCoreLoadModule {}
